import type { SafeString } from '@ember/template';
import Component from '@glimmer/component';

import type { BillingFeature } from 'webapp/enums/enums';

import BillingForbiddenFeatureComponent from 'webapp/components/billing/forbidden-feature';

export default abstract class CommonDisabledOverlayComponent<T> extends Component<T> {
	abstract get feature(): BillingFeature;

	abstract get overlayStyle(): SafeString;

	get trackingOrigin(): string | undefined {
		// when undefined, will track feature as the origin
		return undefined;
	}
	<template>
		<div
			class="disabled-overlay forbidden-feature disabled-overlay_feature--{{this.feature}}"
			style={{this.overlayStyle}}
		>
			<div class="blur"></div>
			<div class="content">
				<BillingForbiddenFeatureComponent
					@feature={{this.feature}}
					@trackingOrigin={{this.trackingOrigin}}
					@isTextOnly={{true}}
				/>
			</div>
		</div>
	</template>
}
